module.exports = __webpack_public_path__ + "img/filecsv.6e0001dd.svg";